<template>
  <div id="signInSuccessfulPageWrapper" class="page">
    <el-row class="hp-row content-default" type="flex">
      <div class="left content-column">
        <!-- Sign In Card -->
        <div id="signin">
          <div class="sign-in-card gradient-card default">

            <div class="header">
              <h4 class="title"> {{ $t('label.login') }} </h4>
            </div>

            <div class="body">
              <i class="icon"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="right content-column">
        <div class="desc-wrapper">
          <!-- Default Description -->
          <template v-if="showDefaultDescription">
            <!-- For Paid Users --->
            <template v-if="$currentUser.hasGroupExtended()">
              <div v-if="!showPlayerSetupDesc" class="desc-default">
                <h1> {{`${$utils.options.plans.PREMIUM.toUpperCase()}.`}} </h1>
                <h1> {{$t('label.loginOKStringTitle2')}} </h1>

                <p> {{$t('label.loginOKStringDesc1')}} </p>
                <p class="p2"> {{$t('label.loginOKStringDesc2')}} </p>
              </div>

              <div v-if="showPlayerSetupDesc" class="desc">
                <h1> {{$t('label.loginOKString4')}} </h1>

                <p class="setup-desc"> {{$t('label.loginOKString5')}} </p>
                <router-link to="/player" custom v-slot="{ navigate }">
                  <div @click="navigate" @keypress.enter="navigate" role="link">
                    <el-button class="cstm-btn-black">{{ $t('label.setup') }}</el-button>
                  </div>
                </router-link>
              </div>
            </template>
            <!-- For Free Users --->
            <template v-else>
              <div v-if="!showPlayerSetupDesc && storageSize.percentage < 75" class="desc-default">
                <h1> {{`${$utils.options.plans.PREMIUM.toUpperCase()}.`}} </h1>
                <h1> {{$t('label.loginOKStringTitle2')}} </h1>

                <p> {{$t('label.loginOKStringDesc1')}} </p>
                <p class="p2"> {{$t('label.loginOKStringDesc2')}} </p>
              </div>

              <div v-if="showPlayerSetupDesc && storageSize.percentage < 75" class="desc">
                <h1> {{$t('label.loginOKString4')}} </h1>

                <p class="last-ch"> {{$t('label.loginOKString5')}} </p>
                <router-link to="/player" custom v-slot="{ navigate }">
                  <div @click="navigate" @keypress.enter="navigate" role="link">
                    <el-button class="cstm-btn-black">{{ $t('label.setup') }}</el-button>
                  </div>
                </router-link>
              </div>

              <div v-if="storageSize.percentage > 75" class="desc">
                  <template v-if="storageSize.percentage > 75 && storageSize.percentage <= 90">
                    <h1> {{$t('label.loginOKQuotaWarnMain', {percentage: Math.floor(storageSize.percentage)})}} </h1>
                    <p class="last-ch"> {{$t('label.loginOKQuotaWarnSub', { plan: $utils.options.plans.PREMIUM.toUpperCase() } )}} </p>
                  </template>
                  <template v-else-if="storageSize.percentage > 90 && storageSize.percentage < 100">
                    <h1> {{$t('label.loginOKQuotaReachedMain', {percentage: Math.floor(storageSize.percentage)})}} </h1>
                    <p class="last-ch"> {{$t('label.loginOKQuotaReachedSub', { plan: $utils.options.plans.PREMIUM.toUpperCase() })}} </p>
                  </template>
                  <template v-else-if="storageSize.percentage >= 100">
                    <h1> {{$t('label.loginOKQuotaExcededMain', {percentage: Math.floor(storageSize.percentage)})}} </h1>
                    <p class="last-ch"> {{$t('label.loginOKQuotaExcededSub', { plan: $utils.options.plans.PREMIUM.toUpperCase() })}} </p>
                  </template>
              </div>

              <router-link v-if="!showPlayerSetupDesc" to="/plans" custom v-slot="{ navigate }">
                <el-button @click="navigate" @keypress.enter="navigate" role="link" class="cstm-btn-black upgrade-plan-btn">{{ $t('label.upgrade', 2) }}</el-button>
              </router-link>
            </template>

            <!-- Storage size -->
            <div v-if="showStorageSize" class="storage-pb">
              <div :class="{'percentage': true, 'animate': storageSize.percentage !== 0 }"
                :style="{ width: `${storageSize.percentage}%` }">
              </div>
            </div>
          </template>

          <!-- Enterprise Description -->
          <template v-if="showEnterpriseDescription">
            <div v-if="showPlayerSetupDesc" class="desc enterprise">
              <h1> {{$t('label.loginOKString4')}} </h1>
              <p class="setup-desc"> {{$t('label.loginOKString5')}} </p>
              <router-link to="/player" custom v-slot="{ navigate }">
                <div>
                  <el-button @click="navigate" @keypress.enter="navigate" role="link" class="cstm-btn-black">{{ $t('label.setup') }}</el-button>
                </div>
              </router-link>

            </div>
            <div class="desc enterprise default" v-else>
              <h1>{{productName}}</h1>
              <p>{{$t('label.loginString3')}}</p>
            </div>
          </template>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script src="./sign-in-successful.js"></script>
<style lang="scss" src="./sign-in-successful.scss"></style>
